/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyGDPRSchema } from '../models/CompanyGDPRSchema';
import type { PatientGdprConsentCreateSchema } from '../models/PatientGdprConsentCreateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GdprApi {
    /**
     * Get Patient Gdpr
     * Get GDPR page associated with patient.
     * @returns CompanyGDPRSchema OK
     * @throws ApiError
     */
    public static gdprGetPatientGdprGet({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<CompanyGDPRSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/gdpr/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Update Patient Gdpr
     * Update patient GDPR.
     * @returns any OK
     * @throws ApiError
     */
    public static gdprUpdatePatientGdprPut({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody?: (PatientGdprConsentCreateSchema | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/gdpr/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient Gdpr Pdf
     * Generate a PDF of the GDPR page associated with patient (for printing). Public like the page, so the patient data in its header is limited to the name.
     * @returns binary PDF document
     * @throws ApiError
     */
    public static gdprGetPatientGdprPdfGet({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/gdpr/{patient_id}/pdf/',
            path: {
                'patient_id': patientId,
            },
        });
    }
}
